import { useEffect, useState } from "react";
import IAM_LOGO_B64 from "../assets/logoData";

export default function InstallBanner() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow]   = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("iam_install_dismissed")) return;
    if (window.matchMedia("(display-mode: standalone)").matches) return;

    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);
    if (ios) { setIsIOS(true); setShow(true); return; }

    const handler = (e) => { e.preventDefault(); setDeferredPrompt(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", () => setShow(false));
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setShow(false);
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem("iam_install_dismissed", "1");
  };

  if (!show) return null;

  return (
    <div style={S.banner}>
      <div style={S.left}>
        <img src={IAM_LOGO_B64} alt="IAM" style={S.logo} />
        <div>
          <p style={S.title}>Installer l'application</p>
          {isIOS
            ? <p style={S.sub}>Appuyez sur <strong>⎙ Partager</strong> → <strong>"Sur l'écran d'accueil"</strong></p>
            : <p style={S.sub}>Accès rapide depuis votre téléphone</p>
          }
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
        {!isIOS && (
          <button style={S.installBtn} onClick={handleInstall}>Installer</button>
        )}
        <button style={S.closeBtn} onClick={handleDismiss}>✕</button>
      </div>
    </div>
  );
}

const S = {
  banner: { position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999, background: "linear-gradient(135deg,#1a3a5c,#2e6aa0)", color: "white", padding: "10px 14px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, boxShadow: "0 2px 12px rgba(0,0,0,0.3)", fontFamily: "'Barlow',sans-serif" },
  left:   { display: "flex", alignItems: "center", gap: 10, flex: 1 },
  logo:   { width: 36, height: 36, borderRadius: 8, objectFit: "contain", background: "white", padding: 3, flexShrink: 0 },
  title:  { fontSize: 13, fontWeight: 700, margin: "0 0 2px", color: "white" },
  sub:    { fontSize: 11, margin: 0, color: "#b0d0f0", lineHeight: 1.4 },
  installBtn: { background: "white", color: "#1a3a5c", border: "none", borderRadius: 8, padding: "7px 14px", fontSize: 13, fontWeight: 700, cursor: "pointer" },
  closeBtn: { background: "rgba(255,255,255,0.15)", color: "white", border: "none", borderRadius: 6, width: 28, height: 28, fontSize: 13, cursor: "pointer" },
};
